import { Flex, Spinner } from '@core/ui-elements'

export const LoadingComponent = () => {
  return (
    <Flex alignItems="center" flex="1" justifyContent="center">
      <Spinner />
    </Flex>
  )
}
